import { alpha } from '@mui/material/styles';

/** Chip neutro para metadata da fila (tipo serviço, adere) — não usa primary (reservado a CTAs). */
export const metadataChipSx = (theme) => {
  const palette = (theme.vars || theme).palette;
  const { mode, neutral } = palette;
  const isDark = mode === 'dark';

  return {
    fontWeight: 600,
    color: isDark ? neutral[300] : neutral[700],
    borderColor: neutral[400],
    bgcolor: alpha(neutral[500], isDark ? 0.15 : 0.08),
  };
};
